import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { Alert } from "antd";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";

export const RenderPdf = ({ file }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  return (
    <React.Fragment>
      {file && (
        <Worker workerUrl={`${process.env.PUBLIC_URL}/worker/pdf.worker.min.js`}>
          <Viewer
            renderError={() => (
              <Alert
                message="Ops, houve algum erro!"
                description="Não foi possivel carregar o documento."
                type="error"
                showIcon
              />
            )}
            fileUrl={file}
            plugins={[defaultLayoutPluginInstance]}></Viewer>
        </Worker>
      )}
    </React.Fragment>
  );
};
